import { createApiAction } from '@app/packages/api/utils'
import type { ApiTimeZone } from '@app/packages/api/v2/types/entities'
import { v2Path } from '@app/packages/api/v2/utils'
import type { Point } from '@app/packages/geo/Point'

export const getTimezones = () =>
  createApiAction('getTimezones', dispatch => dispatch<{ data: ApiTimeZone[] }>({ method: 'GET', endpoint: '/api/v2/timezones' }))

export const getTimezonesByLocation = (location: Point) =>
  createApiAction('getTimezonesByLocation', dispatch =>
    dispatch<{ data: ApiTimeZone }>({
      method: 'GET',
      endpoint: v2Path('/api/v2/timezones/by_location', { latitude: location.lat, longitude: location.lon }),
    })
  )
